<template>
  <div class="modal modal-middle" :class="{ show }" @keydown="keymap">
    <div class="modal-box">
      <h3 class="custom-title">{{ title }}</h3>
      <p class="custom-text" v-html="text"></p>
      <div class="flex w-full gap-0 modal-action">
        <button v-if="!onlyOk" ref="cancel" class="flex-1 cancel-btn" @click="onCancel">
          {{ cancelMessage }}
        </button>
        <button ref="ok" class="flex-1 ok-btn" :class="{ 'only-ok': onlyOk }" @click="onOk">
          {{ okMessage }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalComponent',
  props: {
    title: {
      type: String,
      default: function () {
        return this.$t('message.text.alert')
      },
    },
    text: {
      type: String,
      default: '',
    },
    cancelMessage: {
      type: String,
      default: function () {
        return this.$t('message.text.cancel')
      },
    },
    okMessage: {
      type: String,
      default: function () {
        return this.$t('message.text.ok')
      },
    },
    onlyOk: {
      type: Boolean,
      default: true,
    },
    ok: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      show: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.show = true;
      setTimeout(() => {
        this.$refs.ok.focus();
      }, 200);
    }, 0);
  },
  methods: {
    keymap(e) {
      switch (e.keyCode) {
        case 27: // esc
          this.$refs.cancel.focus();
          this.onCancel();
          break;
      }
    },
    onCancel() {
      this.destroy();
    },
    onOk() {
      this.ok();
      if (this.$parent.callback) {
        this.$parent.callback();
      }
      this.destroy();
    },
    destroy() {
      this.show = false;
      setTimeout(() => {
        this.$el.remove();
        this.$destroy();
      }, 200);
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-box {
  min-width: 320px;
  width: fit-content;
  padding: 0;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.custom-title {
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  color: $gray-09;
  margin-top: 30px;
}
.custom-text {
  padding: 0 20px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  color: $gray-07;
  margin-top: 16px;
  white-space: pre;
  text-align: center;
}
.modal {
  pointer-events: auto;
  visibility: visible;
}
.show {
  opacity: 1;
}
.modal-action {
  margin-top: 30px;
}
.ok-btn {
  height: 48px;
  color: $White;
  font-size: 14px;
  font-weight: 700;
  border: none;
  border-radius: 0 0 4px 0;
  background: $grm-blue-06;
  margin: 0 !important;
  &.only-ok {
    border-radius: 0 0 4px 4px;
  }
  &:focus {
    outline: none;
  }
}
.cancel-btn {
  height: 48px;
  color: $gray-07;
  font-size: 14px;
  font-weight: 700;
  border: none;
  border-radius: 0 0 0 4px;
  background: $gray-01;
  &:focus {
    outline: none;
  }
}
</style>
